<template>
  <div class="employee-debtors-send-email-panel-single-email-form">
    <div class="employee-debtors-send-email-panel-single-email-form__row">
      <app-input label="Email" placeholder="Введите email" v-model="email" :danger.sync="emailError"
                 danger-text="Введите корректный email"/>
    </div>
    <div class="employee-debtors-send-email-panel-single-email-form__row">
      <app-input label="Тема письма" placeholder="Тема" v-model="name" :danger.sync="nameError"
                 danger-text="Введите тему письма"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SingleEmailForm",
    data() {
      return {
        name: null,
        nameError: false,
        emailError: false,
        email: null,
      };
    },
    methods: {
      resetErrors(){
        this.emailError = false;
        this.nameError = false;
      },
      checkErrors() {
        if (this.email === null || !this.email.trim().length || !this.$checkEmail(this.email.trim())) {
          this.emailError = true;
        }

        if(this.name === null || !this.name.trim().length){
          this.nameError = true;
        }

        return this.emailError || this.nameError;
      },
      getBody(){
        return {
          name: this.name,
          email: this.email,
        }
      }
    }
  }
</script>

<style lang="scss">
.employee-debtors-send-email-panel-single-email-form{
  width: 100%;

  &__row{
    margin-bottom: 15px;
  }
}
</style>
